<template>
  <div :class="['app-toast', `app-toast--${toast.type}`]" role="alert">
    <i :class="['bi', iconClass, 'app-toast__icon']"></i>
    <div class="app-toast__body">
      <span class="app-toast__title">{{ toast.title }}</span>
      <span v-if="toast.message" class="app-toast__message">{{ toast.message }}</span>
    </div>
    <button v-if="toast.actionLabel" type="button" class="app-toast__action" @click="handleAction">
      {{ toast.actionLabel }}
    </button>
    <button
      type="button"
      class="btn-close app-toast__close"
      aria-label="Close"
      @click="$emit('dismiss', toast.id)"
    ></button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Toast } from '@/composables/useToast'

const ICON_MAP: Record<string, string> = {
  success: 'bi-check-circle-fill',
  error: 'bi-x-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  info: 'bi-info-circle-fill',
}

const props = defineProps<{
  toast: Toast
}>()

const emit = defineEmits<{ (e: 'dismiss', id: Toast['id']): void }>()

function handleAction() {
  props.toast.onAction?.()
  emit('dismiss', props.toast.id)
}

const iconClass = computed(() => ICON_MAP[props.toast.type])
</script>
